module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/hojadeseguimiento/exploracion/exploraciondetalle/exploraciondetalle.component.scss
// module id = ./src/app/consulta/hojadeseguimiento/exploracion/exploraciondetalle/exploraciondetalle.component.scss
// module chunks = main